import difference from 'lodash/difference';
import {
  GET_LEARNING_GAPS_SUCCESS,
  GET_LEARNING_GAPS_PER_STUDENT_SUCCESS,
  LEARNING_GAPS_REQUEST,
  LEARNING_GAPS_FAILURE,
  CLEAR_LEARNING_GAPS,
  ASSIGN_LEARNING_GAPS_REQUEST,
  ASSIGN_LEARNING_GAPS_SUCCESS,
  ASSIGN_LEARNING_GAPS_FAILURE,
  UPDATE_LEARNING_JOURNEYS_INDEX,
  UPDATE_LEARNING_JOURNEYS_STATE
} from './link-upf-modal-actions';
import { CHECKED, DISABLED } from '../../components/checkbox/constants';
import { DEFAULT_STUDENT_ID } from '../../containers/link-upf-modal/link-upf-modal-utils';
import { customSort } from '../../components/student-list/student-list-util';

export const initialState = {
  isLoading: false,
  isLoadingLJ: false,
  learningJourneys: {}
};

const linkUpfModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case LEARNING_GAPS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ASSIGN_LEARNING_GAPS_REQUEST:
      return {
        ...state,
        isLoadingLJ: true
      };
    case LEARNING_GAPS_FAILURE:
      return {
        ...state,
        isLoading: false
      };
    case ASSIGN_LEARNING_GAPS_SUCCESS:
    case ASSIGN_LEARNING_GAPS_FAILURE:
      return {
        ...state,
        isLoadingLJ: false
      };
    case GET_LEARNING_GAPS_SUCCESS:
      return {
        isLoading: false,
        ...action.payload,
        learningJourneys: action.payload.learningJourneys ? {
          [DEFAULT_STUDENT_ID]: action.payload.learningJourneys
            .map((lj, index) => ({
              ...lj,
              index,
              checkboxState: difference(action.payload.studentProfileIds, lj.assignedStudents).length ?
                CHECKED :
                DISABLED
            }))
        } : {}
      };
    case GET_LEARNING_GAPS_PER_STUDENT_SUCCESS: {
      const studentData = action.payload.groups.length ?
        action.payload.groups.reduce(
          (allStudents, group) => [
            ...allStudents,
            ...(group.students).map(student => ({
              ...student,
              groupPct: group.groupPct,
              classroomPct: action.payload.classroomPct,
              learningJourneys: student.learningJourneys.map((lj, index) => ({
                ...lj,
                index
              }))
            }))
          ], [])
        : [{
          firstName: '',
          lastName: '',
          classroomPct: 0,
          groupPct: 0,
          studentPct: 0,
          questions: [],
          id: 0
        }];

      const sortedStudentData = customSort(studentData, ['lastName', 'firstName']);
      return {
        ...action.payload,
        isLoading: false,
        students: sortedStudentData,
        learningJourneys: action.payload.groups
          .reduce((students, group) => [
            ...students,
            ...group.students
          ], [])
          .reduce((learningJourneys, student) => ({
            ...learningJourneys,
            [student.id]: student.learningJourneys
              .map((lj, index) => ({
                ...lj,
                index,
                checkboxState: lj.assignedStudents.includes(student.id) ? DISABLED : CHECKED
              }))
          }), {})
      };
    }
    case CLEAR_LEARNING_GAPS:
      return initialState;
    case UPDATE_LEARNING_JOURNEYS_INDEX: {
      const studentLearningJourneys = [...state.learningJourneys[action.studentId]];
      studentLearningJourneys[action.index] = {
        ...studentLearningJourneys[action.index],
        checkboxState: action.state
      };
      return {
        ...state,
        learningJourneys: {
          ...state.learningJourneys,
          [action.studentId]: studentLearningJourneys
        }
      };
    }
    case UPDATE_LEARNING_JOURNEYS_STATE: {
      const updateLearningJourneys = ljs => ljs.map(lj => ({
        ...lj,
        checkboxState: lj.checkboxState === action.currentState ? action.nextState : lj.checkboxState
      }));
      if (action.studentId) {
        return {
          ...state,
          learningJourneys: {
            ...state.learningJourneys,
            [action.studentId]: updateLearningJourneys(state.learningJourneys[action.studentId])
          }
        };
      }
      return {
        ...state,
        learningJourneys: Object.entries(state.learningJourneys)
          .reduce((newLearningJourneys, [studentId, ljs]) => ({
            ...newLearningJourneys,
            [studentId]: updateLearningJourneys(ljs)
          }), {})
      };
    }
    default:
      return state;
  }
};

export default linkUpfModalReducer;
